import type { NamePath, AdditionalFormError } from '@xbcb/ui-types';
import type { PgaWithDisclaim } from './pgaWithDisclaim';

interface ValidateCpscProps {
  pga: PgaWithDisclaim;
  getField: (fieldName: string | (string | number)[]) => NamePath;
}

export const validateCpsc = ({
  pga,
  getField,
}: ValidateCpscProps): {
  validateFields: NamePath[];
  additionalErrors: AdditionalFormError[];
} => {
  const validateFields: NamePath[] = [];
  const additionalErrors: AdditionalFormError[] = [];

  return { validateFields, additionalErrors };
};
